// .button-disabled only blocks the mouse: the attribute keeps the control out of the tab order and
// stops Enter, so a link cannot be followed and a modal trigger cannot open while it looks disabled.
export const setDisabled = (element, disabled) => {
  element.classList.toggle('button-disabled', disabled);

  if (element instanceof HTMLButtonElement || element instanceof HTMLInputElement) {
    element.disabled = disabled;
  } else {
    element.toggleAttribute('inert', disabled);
  }
};
